import React, { useRef } from 'react';
import { WEBSITE_PUBLIC_CDN } from 'util/constants';
import ProductsButton from '@src/components/ui-kit/buttons/ProductsButton';
import { openNewTab } from 'util/helpers';
import { Flex } from 'antd';
import { cube, growUp, chart, chain } from './svg-resources/landing-svgs';
import styles from './studio-section.module.css';

export default function UniqueSection() {
  return (
    <div className={styles.root} data-cy='unique-section'>
      <div className={styles.sectionMiddleContent}>
        <span className={styles.sectionMiddleContentTitle}>
          What Makes It Unique?
        </span>
        <Flex
          align='center'
          justify='center'
          gap={16}
          className={styles.cardsRowWrapper}
        >
          <Flex
            vertical
            align='start'
            justify='center'
            className={styles.studioMiddleCard}
          >
            <div className={styles.studioSvgWrapper}>{cube}</div>
            <span className={styles.cardTitle}>
              Showcase of Cutting-Edge 3D & AI Tech
            </span>
            <p className={styles.cardText}>
              With live services, in game economy, and the powerful OZONE gaming
              technologies.
            </p>
          </Flex>
          <Flex
            vertical
            align='start'
            justify='center'
            className={styles.studioMiddleCard}
          >
            <div className={styles.studioSvgWrapper}>{growUp}</div>
            <span className={styles.cardTitle}>
              Persistent & Expanding World
            </span>
            <p className={styles.cardText}>
              The game evolves with every season.
            </p>
          </Flex>
        </Flex>
        <Flex
          align='center'
          justify='center'
          gap={16}
          className={styles.cardsRowWrapper}
        >
          <Flex
            vertical
            align='start'
            justify='center'
            className={styles.studioMiddleCard}
          >
            <div className={styles.studioSvgWrapper}>{chart}</div>
            <span className={styles.cardTitle}>Community-Driven Economy</span>
            <p className={styles.cardText}>
              Players earn, trade, and build together.
            </p>
          </Flex>
          <Flex
            vertical
            align='start'
            justify='center'
            className={styles.studioMiddleCard}
          >
            <div className={styles.studioSvgWrapper}>{chain}</div>
            <span className={styles.cardTitle}>
              Web3-Enabled & Interoperable
            </span>
            <p className={styles.cardText}>
              Easily use our software blueprint to bring your ecosystem and game
              economy to life
            </p>
          </Flex>
        </Flex>
        <div className={styles.buttonWrapper}>
          <ProductsButton
            onClick={() => openNewTab('https://arena.ozonemetaverse.io/game')}
          >
            ENTER THE ARENA
          </ProductsButton>
        </div>
      </div>
      <div className={styles.bottomBlockWrapper}>
        <img
          src={`${WEBSITE_PUBLIC_CDN}/gaming-page-pic.png`}
          alt='Unified Bulider Section image'
          className={styles.uniqueSectionImage}
        />
        <span className={styles.bottomBlockTitle}>
          Looking for game technologies or just curious about our stack?
        </span>
        <div className={styles.uniqueSectionButtonWrapper}>
          <ProductsButton
            type='white'
            onClick={() =>
              openNewTab(
                'https://calendly.com/ozonetechnologies/free-consult-discovery'
              )
            }
          >
            TALK TO US
          </ProductsButton>
        </div>
      </div>
    </div>
  );
}
